import {
  ArrowLeftCircle,
  InfoEmpty,
  MessageText,
  MoreHorizCircle,
  Trash,
} from 'iconoir-react'

import React, { memo, useEffect, useMemo, useRef, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import { useNavigate, useParams } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import PDFViewer from '../../components/PDFViewer/PDFViewer'
import { getExtensionFile, getNameInCapitalize } from '../../utils/common'
import { useMediaQuery } from 'react-responsive'
import moment from 'moment'
import { DATE_FORMAT_DEFAULT } from '../../utils/constants'
import { EmptyText, WordBreak } from '../../components/common/CellText'
import FileItem from '../../components/FileItemComponent/FileItem'
import LinkedTask from '../../components/Linked/LinkedTask'
import LinkedWork from '../../components/Linked/LinkedWork'
import PeopleTag from '../../components/PeopleTag'
import { Menu, MenuItem, useTheme } from '@mui/material'
import ListComment from '../InternalDocumentOutgoing/ListComment'
import AlertDialog from '../../components/common/AlertDialog'
import CommentModal from './commentModal'
import { Dropdown, Modal, Steps, Upload, message } from 'antd'
import {
  AiOutlineComment,
  AiOutlineDelete,
  AiOutlineEdit,
  AiOutlineFileText,
  AiOutlineQuestionCircle,
  AiOutlineSolution,
} from 'react-icons/ai'
import {
  CalendarOutlined,
  CheckOutlined,
  CloseOutlined,
  InfoCircleTwoTone,
} from '@ant-design/icons'
import { MdOutlineScheduleSend } from 'react-icons/md'
import InternalDocumentOutgoingUpdate from '../InternalDocumentOutgoing/InternalDocumentOutgoingUpdate'
import InternalConnectedDocumentOutgoingCreate from '../InternalConnectedDocumentOutgoing/InternalConnectedDocumentOutgoingCreate'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DOCUMENT_TYPE,
  ELECTRONIC_DOCUMENT_STATUS,
} from '../../constants'
import queryString from 'query-string'
import Message from '../../components/common/Message'
import PopupHandleDocumentOutgoing from '../InternalDocumentOutgoing/PopupHandleDocumentOutgoing'
import PopupPhanPhatDocumentOutgoing from '../InternalDocumentOutgoing/PopupPhanPhatDocumentOutgoing'
import {
  ButtonItem,
  CanvasDocHeader,
  ViewerWrapper,
} from './InternalDocumentSignDocDetailStyled'
import utils from '../../utils'
import AccessControlAction from '../../components/AccessControlAction/AccessControlAction'
import { AvatarHasName } from '../../components/common/Avatar'
import { blue } from '../../color'
const { Step } = Steps
const InternalDocumentSignDetail = props => {
  const {
    electronicDocumentStore,
    fileStore,
    loadingAnimationStore,
    signedDocumentStore,
  } = props
  const commentRef = useRef(null)
  const executeScroll = () => commentRef.current.scrollIntoView()
  const [messageCreate, setMessageCreate] = useState('')
  const [openMessage, setOpenMessage] = useState(false)
  const [severity, setSeverity] = useState('')
  const createMessage = (messageCreate, openMessage, severity) => {
    setMessageCreate(messageCreate)
    setOpenMessage(openMessage)
    setSeverity(severity)
  }
  const {
    selectedElectronicDocument,
    getCommentElectronicDocumentList,
    commentElectronicDocumentList,
    deleteCommentElectronicDocument,
  } = electronicDocumentStore
  const {
    assignees,
    title,
    code,
    date_issued,
    agency_issued,
    attachments,
    linked_work,
    action_history,
    status,
    created_date,
  } = selectedElectronicDocument
  const linkedWorkList = linked_work && linked_work.code ? [linked_work] : []
  const commentInDocListNotDeleted = commentElectronicDocumentList?.filter(
    item => item.deleted !== true
  )
  const commentInDocListDeleted = commentElectronicDocumentList?.filter(
    item => item.deleted === true
  )
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })
  const { documentAttachment } = fileStore
  const { documentId } = useParams()
  const [open, setOpen] = React.useState(false)
  const navigate = useNavigate()
  const [attachmentForView, setAttachmentForView] = useState()
  const [openCmt, setOpenCmt] = useState(false)
  const [openMore, setOpenMore] = useState(false)
  const [openCmtDel, setOpenCmtDel] = useState(false)
  const [openUpdate, setOpenUpdate] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingCmt, setLoadingCmt] = useState(false)
  const [fileActiveIsPDF, setFileActiveIsPDF] = useState(false)
  const [deleteItem, setDeleteItem] = useState({
    open: false,
    id_comment: '',
  })
  const [fileActive, setFileActive] = useState()
  const [handlerName, setHandlerName] = useState({
    vt_approval_name: undefined,
    lead_approval_name: undefined,
    regis_number_name: undefined,
    sign_document_name: undefined,
    release_name: undefined,
  })
  const [isVisiblePopupRegisNumber, setIsVisiblePopupRegisNumber] =
    useState(false)
  const [isVisiblePopupSign, setIsVisiblePopupSign] = useState(false)
  const [isVisiblePopupRelease, setIsVisiblePopupRelease] = useState(false)
  const [isSkipSign, setIsSkipSign] = useState(false)

  const combinerList = assignees
    ? assignees.filter(el => el.permission === ASSIGNEE_TYPE.COMBINER)
    : []
  const leader =
    assignees && assignees.find(el => el.permission === ASSIGNEE_TYPE.LEADER)
  const creator =
    assignees && assignees.find(el => el.permission === ASSIGNEE_TYPE.CREATE)

  const [currentStep, setCurrentStep] = useState(0)
  const [statusStep, setStatusStep] = useState([
    'process',
    'await',
    'await',
    'await',
    'await',
  ])
  useEffect(() => {
    if (status === ELECTRONIC_DOCUMENT_STATUS.PENDING) {
      setCurrentStep(0)
      setStatusStep(['process', 'await', 'await', 'await', 'await'])
    }
    if (status === ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL) {
      setCurrentStep(1)
      setStatusStep(['finish', 'process', 'await', 'await', 'await'])
    }
    if (status === ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL) {
      setCurrentStep(2)
      setStatusStep(['finish', 'finish', 'process', 'await', 'await'])
    }
    if (status === ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER) {
      setCurrentStep(3)
      setStatusStep(['finish', 'finish', 'finish', 'process', 'await'])
    }
    if (status === ELECTRONIC_DOCUMENT_STATUS.READY) {
      setCurrentStep(4)
      setStatusStep(['finish', 'finish', 'finish', 'finish', 'process'])
    }
    if (status === ELECTRONIC_DOCUMENT_STATUS.RELEASE) {
      setCurrentStep(5)
      setStatusStep(['finish', 'finish', 'finish', 'finish', 'finish'])
    }
  }, [status])
  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleDeleteComment = async () => {
    setDeleteItem({ open: false, comment_id: '' })
    try {
      setLoading(true)
      await deleteCommentElectronicDocument(documentId, deleteItem.id_comment)
      await getCommentElectronicDocumentList(documentId)
      createMessage('Xóa ý kiến thành công!', true, 'success')
    } catch (err) {
      createMessage(err.vi, true, 'error')
    } finally {
      setLoading(false)
    }
  }
  const [isVisiblePopupHandleDocument, setIsVisiblePopupHandleDocument] =
    useState(false)
  const [isVisiblePopupPhanPhat, setIsVisiblePopupPhanPhat] = useState(false)
  const [fileExt, setFileExt] = useState(undefined)
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] =
    useState(false)
  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ['rename'],
      value: '',
    },
  ])
  const handleClose = () => {
    setAnchorEl(null)
  }
  const opens = Boolean(anchorEl)
  let menu = (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={opens}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}>
      {openMore ? (
        <MenuItem
          sx={{
            color: '#0073C7 !important',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
            fontSize: '12px',
          }}
          onClick={() => {
            setOpenMore(false)
            setOpenCmtDel(false)
            handleClose()
          }}>
          <Trash width={12} height={14} className="mr-1" />
          Ẩn ý kiến đã xóa
        </MenuItem>
      ) : (
        <MenuItem
          onClick={() => {
            setOpenMore(true)
            setOpenCmtDel(true)
            handleClose()
          }}
          sx={{
            color: '#0073C7 !important',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
            fontSize: '12px',
          }}>
          <Trash width={12} height={14} className="mr-1" />
          Hiện ý kiến đã xóa
        </MenuItem>
      )}
    </Menu>
  )
  useEffect(() => {
    ;(async () => {
      try {
        await electronicDocumentStore.getCommentElectronicDocumentList(
          documentId
        )
      } catch (err) {
        navigate(-1)
      } finally {
      }
    })()
    return () => {
      electronicDocumentStore.clearCommentElectronicDocumentList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentId])

  useEffect(() => {
    if (!action_history) return
    const fileInfo = action_history.find(el => el.action === status)
    setFileActive(fileInfo)
    utils.getExtensionFile(fileInfo?.file_name)
    const isPDFFile = utils.getExtensionFile(fileInfo?.file_name) === 'pdf'
    setFileActiveIsPDF(isPDFFile)

    const vt_approval_name = action_history.find(
      el => el.action === ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL
    )?.user.name_lowercase
    const lead_approval_name = action_history.find(
      el => el.action === ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL
    )?.user.name_lowercase
    const regis_number_name = action_history.find(
      el => el.action === ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER
    )?.user.name_lowercase
    const sign_document_name = action_history.find(
      el => el.action === ELECTRONIC_DOCUMENT_STATUS.READY
    )?.user.name_lowercase
    const release_name = action_history.find(
      el => el.action === ELECTRONIC_DOCUMENT_STATUS.RELEASE
    )?.user.name_lowercase
    setHandlerName({
      vt_approval_name: vt_approval_name,
      lead_approval_name: lead_approval_name,
      regis_number_name: regis_number_name,
      sign_document_name: sign_document_name,
      release_name: release_name,
    })
    if (
      action_history &&
      action_history.find(
        el => el.action === ELECTRONIC_DOCUMENT_STATUS.READY
      ) &&
      action_history.find(
        el => el.action === ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER
      ) &&
      action_history.find(el => el.action === ELECTRONIC_DOCUMENT_STATUS.READY)
        .file_id ===
        action_history.find(
          el => el.action === ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER
        ).file_id
    ) {
      setIsSkipSign(true)
    } else {
      setIsSkipSign(false)
    }
  }, [action_history])

  useEffect(() => {
    if (!action_history) return
    setAttachmentForView(action_history)
  }, [action_history])
  const theme = useTheme()
  const renderAttachment = useMemo(() => {
    if (!documentAttachment) return null
    return (
      <ViewerWrapper>
        <PDFViewer
          file={documentAttachment}
          fileId={fileActive?.file_id}
          fileType={utils.getExtensionFile(fileActive?.file_name)}
        />
      </ViewerWrapper>
    )
  }, [documentAttachment, fileActive])

  const handleClickOpenInfo = e => {
    e.stopPropagation()
    setOpen(true)
    document.body.style.overflow = 'hidden'
  }

  const handleCloseInfo = () => {
    setOpen(false)
    document.body.style.overflow = 'auto'
  }

  const descriptionElementRef = React.useRef(null)
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef
      if (descriptionElement !== null) {
        descriptionElement.focus()
      }
    }
  }, [open])

  const { confirm } = Modal
  const handleDeleteDoc = async () => {
    try {
      await electronicDocumentStore.deleteElectronicDocument(documentId)
    } catch (err) {
      // console.log(err)
    } finally {
      message.success('Xóa văn bản thành công!')
      navigate(-1)
    }
  }
  const showConfirmDeleteDoc = () => {
    confirm({
      title: 'Bạn có muốn xóa trình ký này không?',
      icon: (
        <AiOutlineQuestionCircle
          style={{ color: 'red', width: '30px', height: '30px' }}
        />
      ),
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteDoc()
      },
    })
  }
  function findProcessOrder(arr) {
    return arr.indexOf('process')
  }

  const handleVTApproval = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL,
          file_id: fileActive.file_id,
        },
        code
      )
      await electronicDocumentStore.getElectronicDocumentById(code)
      message.success('Văn thư đã duyệt thành công!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  const handleLeaderApproval = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL,
          file_id: fileActive.file_id,
        },
        code
      )
      await electronicDocumentStore.getElectronicDocumentById(code)
      message.success('Lãnh đạo đã duyệt thành công!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  const handleRevertLeaderApproval = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL,
          file_id: action_history.find(
            el => el.action === ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL
          ).file_id,
        },
        code
      )
      const { data } = await electronicDocumentStore.getElectronicDocumentById(
        code
      )
      await fileStore.downloadAttachment(
        data.action_history.find(el => el.action === data.status).file_id
      )
      message.info('Lãnh đạo đã hủy duyệt trình ký!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  const handleOpenPopupSign = () => {
    if (!fileActiveIsPDF) {
      return message.info('Bạn chỉ được phép ký số file PDF')
    }
    signedDocumentStore.setFileBlob(documentAttachment)
    signedDocumentStore.setOriginFileObj({
      name: fileActive.file_name,
    })
    setIsVisiblePopupSign(true)
  }
  const showReleaseConfirm = () => {
    confirm({
      title: 'Bạn có chắc chắn muốn phát hành tài liệu này?',
      icon: <InfoCircleTwoTone />,
      content: '',
      okText: 'Đồng ý',
      okType: 'primary',
      cancelText: 'Hủy bỏ',
      onOk() {
        setIsVisiblePopupRelease(true)
      },
      onCancel() {
        console.log('Hủy phát hành')
      },
    })
  }
  const onSelectDocument = async file => {
    const formData = new FormData()
    formData.append('file', file.file)
    loadingAnimationStore.showSpinner(true)
    try {
      const res = await fileStore.uploadFile(formData)
      await electronicDocumentStore.updateFileElectronic(
        res.data.file_id,
        status,
        code
      )
      const response = await electronicDocumentStore.getElectronicDocumentById(
        code
      )
      await fileStore.downloadAttachment(
        response.data.action_history.find(
          el => el.action === response.data.status
        ).file_id
      )
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  const handledDismissSign = async () => {
    const updateStatusData = {
      action: ELECTRONIC_DOCUMENT_STATUS.READY,
      file_id: fileActive.file_id,
    }
    loadingAnimationStore.showSpinner(true)
    try {
      await electronicDocumentStore.updateElectronicDocumentStatus(
        updateStatusData,
        code
      )
      await electronicDocumentStore.getElectronicDocumentById(code)
      message.success('Bạn đã bỏ qua bước ký số!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  const showRevertNumberConfirm = () => {
    confirm({
      title: 'Bạn có muốn cấp lại số tài liệu?',
      icon: <InfoCircleTwoTone />,
      content: '',
      okText: 'Đồng ý',
      okType: 'primary',
      cancelText: 'Hủy bỏ',
      onOk() {
        handleRevertRegisNumber().then()
      },
      onCancel() {
        console.log('Hủy phát hành')
      },
    })
  }
  const handleOpenPopupRenameFile = () => {
    setFileExt('.' + utils.getExtensionFile(fileActive.file_name))
    setIsModalVisibleRenameFile(true)
    setFieldsRenameFile([
      {
        name: ['rename'],
        value:
          fileActive.file_name &&
          utils.removeExtensionFile(fileActive.file_name),
      },
    ])
  }
  const showSignRevertConfirm = () => {
    confirm({
      title: 'Bạn có chắc chắn muốn ký số lại tài liệu này?',
      icon: <InfoCircleTwoTone />,
      content: '',
      okText: 'Đồng ý',
      okType: 'primary',
      cancelText: 'Hủy bỏ',
      onOk() {
        handleRevertSign().then()
      },
      onCancel() {
        console.log('Hủy kí số lại')
      },
    })
  }
  const handleRevertRegisNumber = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL,
          file_id: action_history.find(
            el => el.action === ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL
          ).file_id,
        },
        code
      )
      const { data } = await electronicDocumentStore.getElectronicDocumentById(
        code
      )
      await fileStore.downloadAttachment(
        data.action_history.find(el => el.action === data.status).file_id
      )
      message.info('Hãy cấp lại số tài liệu')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  const handleRevertSign = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await electronicDocumentStore.updateElectronicDocumentStatus(
        {
          action: ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER,
          file_id: action_history.find(
            el => el.action === ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER
          ).file_id,
        },
        code
      )
      const { data } = await electronicDocumentStore.getElectronicDocumentById(
        code
      )
      await fileStore.downloadAttachment(
        data.action_history.find(el => el.action === data.status).file_id
      )
      message.info('Bạn đã quay trở về bước ký số')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  const handledDismissRegisNumber = async () => {
    const updateStatusData = {
      action: ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER,
      file_id: fileActive.file_id,
    }
    try {
      loadingAnimationStore.showSpinner(true)
      await electronicDocumentStore.updateElectronicDocumentStatus(
        updateStatusData,
        code
      )
      await electronicDocumentStore.getElectronicDocumentById(code)
      message.success('Bạn đã bỏ qua bước cấp số!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  const menuVTApproval = (
    <Menu>
      <Menu.Item key="1">
        <Upload
          accept={'.doc,.docx,application/pdf'}
          beforeUpload={() => false}
          showUploadList={false}
          onChange={onSelectDocument}>
          Chọn tài liệu khác
        </Upload>
      </Menu.Item>
    </Menu>
  )
  const menuRegisNumber = (
    <Menu>
      <Menu.Item onClick={handledDismissRegisNumber}>Bỏ qua cấp số</Menu.Item>
      <Menu.Item onClick={handleOpenPopupRenameFile}>
        Đổi tên tài liệu
      </Menu.Item>
      <Menu.Item>
        <Upload
          accept={'.doc,.docx,application/pdf'}
          beforeUpload={() => false}
          showUploadList={false}
          onChange={onSelectDocument}>
          Chọn tài liệu khác
        </Upload>
      </Menu.Item>
    </Menu>
  )

  const menuSignDocument = (
    <Menu>
      <Menu.Item key={'1'} onClick={handledDismissSign}>
        Bỏ qua kí số
      </Menu.Item>
      <Menu.Item key={'2'} onClick={showRevertNumberConfirm}>
        Cấp lại số
      </Menu.Item>
      <Menu.Item key={'3'} onClick={handleOpenPopupRenameFile}>
        Đổi tên tài liệu
      </Menu.Item>
    </Menu>
  )

  const menuReleaseDocument = (
    <Menu>
      <Menu.Item key={'2'} onClick={showSignRevertConfirm}>
        Kí số lại
      </Menu.Item>
      <Menu.Item key={'3'} onClick={handleOpenPopupRenameFile}>
        Đổi tên tài liệu
      </Menu.Item>
    </Menu>
  )
  const [openCreateOutgoingDoc, setOpenCreateOutgoingDoc] = useState(false)
  return (
    <div>
      <div
        className="flex items-center p-[20px] gap-[22px] fixed w-full z-50"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}>
        <ArrowLeftCircle
          className="flex-shrink-0"
          onClick={() => {
            navigate(-1)
          }}
        />
        <span
          className="font-bold text-[28px] leading-[29px] "
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
            whiteSpace: 'nowrap',
            marginRight: '5px',
            lineHeight: '35px',
          }}>
          {title}
        </span>
      </div>
      <div className="py-[20px] pt-20">
        <div className={`px-5 }`}>
          <div className="flex justify-between">
            <div
              className="flex justify-center gap-x-2 items-center mt-5 bg-[rgba(0,115,199,0.07);] py-[10px] w-[calc(50%-10px)] text-primary px-[14px] rounded-full text-sm leading-5 cursor-pointer font-medium"
              onClick={handleClickOpenInfo}>
              <div>
                <InfoEmpty />
              </div>
              <span onClick={handleClickOpenInfo}>Thông tin</span>
            </div>
            {/* <div
              className="flex justify-center gap-x-2  items-center mt-5 bg-[rgba(22,25,44,0.07)] py-[10px] w-[calc(50%-10px)]  px-[14px] rounded-full text-sm leading-5 font-medium"
              onClick={() =>
                selectedElectronicDocument?.length > 0 && executeScroll()
              }>
              <div>
                <MessageText />
              </div>
              <span>Ý kiến</span>
            </div> */}
          </div>
          {/* <CanvasDocHeader>
            <Steps
              labelPlacement="vertical"
              size="small"
              direction="horizontal"
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                marginLeft: '20px',
              }}>
              <Step status={statusStep[0]} />
              <Step status={statusStep[1]} />
              <Step status={statusStep[2]} />
              <Step status={statusStep[3]} />
              <Step status={statusStep[4]} />
            </Steps>
          </CanvasDocHeader> */}
          {/* <ButtonItem>
            {currentStep === 0 && (
              <AccessControlAction
                aclActionType={ACL_ACTION_TYPE.van_thu_duyet__PHAT_HANH_VB}>
                <Dropdown.Button
                  size={'large'}
                  trigger={['click']}
                  onClick={handleVTApproval}
                  overlay={menuVTApproval}
                  type={'primary'}>
                  <CheckOutlined style={{ marginRight: 4 }} />
                  Văn thư duyệt
                </Dropdown.Button>
              </AccessControlAction>
            )}
            {currentStep === 1 && (
              <AccessControlAction
                aclActionType={ACL_ACTION_TYPE.lanh_dao_duyet__PHAT_HANH_VB}>
                <Button
                  style={{ width: 350 }}
                  size={'large'}
                  block
                  type="primary"
                  icon={<CheckOutlined />}
                  onClick={handleLeaderApproval}>
                  Lãnh đạo duyệt
                </Button>
              </AccessControlAction>
            )}
            {currentStep === 2 && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <AccessControlAction
                  aclActionType={ACL_ACTION_TYPE.cap_so__PHAT_HANH_VB}>
                  <Dropdown.Button
                    size={'large'}
                    trigger={['click']}
                    onClick={() => {
                      if (!fileActiveIsPDF) {
                        return message.info('Bạn chỉ được phép cấp số file PDF')
                      }
                      setIsVisiblePopupRegisNumber(true)
                    }}
                    overlay={menuRegisNumber}
                    type={'primary'}>
                    <CheckOutlined style={{ marginRight: 4 }} />
                    Cấp số tài liệu
                  </Dropdown.Button>
                </AccessControlAction>
                <AccessControlAction
                  aclActionType={
                    ACL_ACTION_TYPE.lanh_dao_huy_duyet__PHAT_HANH_VB
                  }>
                  <Button
                    onClick={handleRevertLeaderApproval}
                    icon={<CloseOutlined />}
                    type={'primary'}
                    style={{ width: 355, marginTop: 8 }}
                    danger>
                    Lãnh đạo hủy duyệt
                  </Button>
                </AccessControlAction>
              </div>
            )}
            {currentStep === 3 && (
              <AccessControlAction
                aclActionType={ACL_ACTION_TYPE.ky_so_tai_lieu__PHAT_HANH_VB}>
                <Dropdown.Button
                  size={'large'}
                  trigger={['click']}
                  onClick={handleOpenPopupSign}
                  overlay={menuSignDocument}
                  type={'primary'}>
                  <CheckOutlined style={{ marginRight: 4 }} />
                  Ký số tài liệu
                </Dropdown.Button>
              </AccessControlAction>
            )}
            {currentStep === 4 && (
              <AccessControlAction
                aclActionType={
                  ACL_ACTION_TYPE.phat_hanh_tai_lieu__PHAT_HANH_VB
                }>
                <Dropdown.Button
                  size={'large'}
                  trigger={['click']}
                  onClick={showReleaseConfirm}
                  overlay={menuReleaseDocument}
                  type={'primary'}>
                  <CheckOutlined style={{ marginRight: 4 }} />
                  Phát hành tài liệu
                </Dropdown.Button>
              </AccessControlAction>
            )}
          </ButtonItem> */}
          {/* <div>
            <span>Bước: {currentStep + 1}</span>
            <div>
              {currentStep === 0
                ? handlerName.vt_approval_name && (
                    <div>
                      bởi{' '}
                      <span
                        style={{
                          color: '#000',
                          fontWeight: 600,
                        }}>
                        {utils.getNameInCapitalize(
                          handlerName.vt_approval_name
                        )}
                      </span>
                    </div>
                  )
                : currentStep === 1
                ? handlerName.leader_approval_name && (
                    <div>
                      bởi{' '}
                      <span
                        style={{
                          color: '#000',
                          fontWeight: 600,
                        }}>
                        {utils.getNameInCapitalize(
                          handlerName.leader_approval_name
                        )}
                      </span>
                    </div>
                  )
                : currentStep === 2
                ? handlerName.revert_leader_approval_name && (
                    <div>
                      bởi{' '}
                      <span
                        style={{
                          color: '#000',
                          fontWeight: 600,
                        }}>
                        {utils.getNameInCapitalize(
                          handlerName.revert_leader_approval_name
                        )}
                      </span>
                    </div>
                  )
                : currentStep === 3
                ? handlerName.sign_document_name && (
                    <div>
                      bởi{' '}
                      <span
                        style={{
                          color: '#000',
                          fontWeight: 600,
                        }}>
                        {utils.getNameInCapitalize(
                          handlerName.sign_document_name
                        )}
                      </span>
                    </div>
                  )
                : currentStep === 4
                ? handlerName.release_document_name && (
                    <div>
                      bởi{' '}
                      <span
                        style={{
                          color: '#000',
                          fontWeight: 600,
                        }}>
                        {utils.getNameInCapitalize(
                          handlerName.release_document_name
                        )}
                      </span>
                    </div>
                  )
                : null}
            </div>
          </div> */}
          <div className="!w-[100%] mt-[14px] ">{renderAttachment}</div>
          <div ref={commentRef} style={{ paddingBottom: '80px' }}>
            {commentInDocListDeleted?.length > 0 ? (
              <>
                <div className="mt-4 text-sm flex items-center">
                  <div className="font-semibold leading-5 text-labelForm">
                    Danh sách ý kiến
                  </div>
                  <MoreHorizCircle
                    className="text-primary ml-2"
                    onClick={handleClick}
                  />
                  {menu}
                </div>
                {openCmtDel ? (
                  <ListComment
                    loadingCmt={loadingCmt}
                    commentList={commentInDocListDeleted}
                    setDeleteItem={setDeleteItem}
                  />
                ) : (
                  ''
                )}
                <ListComment
                  loadingCmt={loadingCmt}
                  commentList={commentInDocListNotDeleted}
                  setDeleteItem={setDeleteItem}
                />
              </>
            ) : (
              <>
                {commentInDocListNotDeleted?.length > 0 && (
                  <>
                    <div className="mt-4 text-sm flex items-center">
                      <div className="font-semibold leading-5 text-labelForm">
                        Danh sách ý kiến
                      </div>
                      <MoreHorizCircle
                        className="text-primary ml-2"
                        onClick={handleClick}
                      />
                      {menu}
                    </div>
                    {openCmtDel ? (
                      <ListComment
                        loadingCmt={loadingCmt}
                        commentList={commentInDocListDeleted}
                        setDeleteItem={setDeleteItem}
                      />
                    ) : (
                      ''
                    )}
                    <ListComment
                      loadingCmt={loadingCmt}
                      commentList={commentInDocListNotDeleted}
                      setDeleteItem={setDeleteItem}
                    />
                  </>
                )}
              </>
            )}
          </div>
        </div>

        <Dialog
          open={open}
          onClose={handleCloseInfo}
          scroll={'paper'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className="doc-popup"
          fullWidth
          sx={{
            fontWeight: 700,
            '& .MuiDialog-container': {
              '& .MuiPaper-root': {
                width: '100vw',
                maxWidth: '100vw', // Set your width here
                mx: 0,
              },
            },
          }}>
          <DialogTitle
            id="scroll-dialog-title"
            className="text-xl font-bold text-[#23374D] !py-9">
            <span className="font-bold">Thông tin chung</span>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="scroll-dialog-description"
              ref={descriptionElementRef}
              tabIndex={-1}
              className="">
              <table
                style={{ color: '#16192C' }}
                className="doc-table-vertical font-semibold text-sm leading-5 text-[#16192C]">
                <tr>
                  <th
                    style={{
                      paddingBottom: 14,
                      width: '130px',
                      display: 'flex',
                    }}>
                    Người trình ký:
                  </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {creator ? (
                      <AvatarHasName
                        imgId={creator?.image}
                        name={creator?.name_uppercase}
                      />
                    ) : (
                      <EmptyText>Không có.</EmptyText>
                    )}
                  </td>
                </tr>

                <tr>
                  <th style={{ paddingBottom: 14 }}>Người phối hợp: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {combinerList.length !== 0 ? (
                      combinerList.map(el => (
                        <div style={{ marginBottom: 7 }} key={el.assignee_code}>
                          <AvatarHasName
                            imgId={el.image}
                            name={el.name_uppercase}
                          />
                        </div>
                      ))
                    ) : (
                      <EmptyText>Không có người phối hợp</EmptyText>
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Lãnh đạo duyệt ký: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {leader ? (
                      <AvatarHasName
                        imgId={leader?.image}
                        name={leader?.name_uppercase}
                      />
                    ) : (
                      <EmptyText>Không có.</EmptyText>
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Ngày trình ký: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    <CalendarOutlined style={{ color: blue, marginRight: 6 }} />
                    {moment(created_date).format(DATE_FORMAT_DEFAULT)}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }} colSpan={2}>
                    Tài liệu trình ký:{' '}
                  </th>
                </tr>
                <tr>
                  <td
                    className="font-normal"
                    style={{ paddingBottom: 14 }}
                    colSpan={2}>
                    <FileItem
                      file_id={fileActive?.file_id}
                      file_name={fileActive?.file_name}
                      file_type={utils.getExtensionFile(fileActive?.file_name)}
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }} colSpan={2}>
                    Tài liệu đính kèm:{' '}
                  </th>
                </tr>
                <tr>
                  <td
                    className="font-normal"
                    style={{ paddingBottom: 14 }}
                    colSpan={2}>
                    {attachments?.length > 0 ? (
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {attachments.map(file => (
                          <FileItem
                            key={file.file_id}
                            file_id={file.file_id}
                            file_name={file.file_name}
                            file_type={utils.getExtensionFile(file.file_name)}
                            style={{ marginRight: 10, marginBottom: 10 }}
                          />
                        ))}
                      </div>
                    ) : (
                      <EmptyText>Không có tài liệu đính kèm</EmptyText>
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Liên kết công việc: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    <LinkedWork linkedWorkList={linkedWorkList} />
                  </td>
                </tr>
              </table>
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              sx={{ fontWeight: 600 }}
              onClick={handleCloseInfo}
              className="pb-6 text-sm font-semibold leading-5 text-primary">
              Đóng
            </Button>
          </DialogActions>
        </Dialog>
        <CommentModal
          createMessage={createMessage}
          open={openCmt}
          handleClose={() => {
            setOpenCmt(false)
          }}
          inDocCode={documentId}
          // onCommentSuccess={onCommentSuccess}
        />

        <Message
          message={messageCreate}
          openMessage={openMessage}
          severity={severity}
          closeMessage={() => {
            setOpenMessage(false)
          }}
        />
        <footer
          style={{
            position: 'fixed',
            bottom: 0,
            backgroundColor: 'white',
            borderTopRightRadius: '10px',
            borderTopLeftRadius: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className="w-full py-4 shadow-[0px_0px_8px_rgba(0,0,0,0.25)] ">
          <div className="flex justify-center  w-full h-full">
            <div className="block text-center w-[70px] mx-2">
              <div
                className="bg-[rgba(0,115,199,0.07);] text-blue-500 inline-block hover:bg-cyan-400 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
                onClick={() => setOpenCmt(true)}>
                <AiOutlineComment style={{ width: '20px', height: '20px' }} />
              </div>
              <div style={{ fontSize: '11px' }}>Đăng ý kiến</div>
            </div>
            <div className="block text-center w-[70px] mx-2">
              <div
                className="hover:bg-cyan-400 inline-block bg-[rgba(0,115,199,0.07);] text-red-500 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
                onClick={() => showConfirmDeleteDoc()}>
                <AiOutlineDelete style={{ width: '20px', height: '20px' }} />
              </div>
              <div style={{ fontSize: '11px' }}>Xóa</div>
            </div>
          </div>
        </footer>
        <AlertDialog
          open={deleteItem.open}
          handleClose={() => setDeleteItem({ open: false, comment_id: '' })}
          handleDelete={handleDeleteComment}
        />
        {/* <PopupRenameFile
          isModalVisibleRenameFile={isModalVisibleRenameFile}
          handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
          submitRenameFile={submitRenameFile}
          fieldsRenameFile={fieldsRenameFile}
          fileExt={fileExt}
        />
        {isVisiblePopupRelease && (
          <PopupReleaseElectronicDocument
            fileActive={fileActive}
            handleClosePopupElectronicDocument={() =>
              setIsVisiblePopupRelease(false)
            }
            isVisiblePopupRelease={isVisiblePopupRelease}
          />
        )}

        <PopupRegisNumber
          handleClosePopupRegisNumber={() =>
            setIsVisiblePopupRegisNumber(false)
          }
          isVisiblePopupRegisNumber={isVisiblePopupRegisNumber}
          fileActive={fileActive}
        />

        {isVisiblePopupSign && (
          <PopupSign
            isVisiblePopupSign={isVisiblePopupSign}
            handleClosePopupSign={() => {
              setIsVisiblePopupSign(false)
            }}
            hiddenSelectDocument
            fileId={fileActive?.file_id}
            handleAfterSign={handleAfterSign}
          />
        )} */}
      </div>
    </div>
  )
}

export default memo(
  inject(
    'electronicDocumentStore',
    'fileStore',
    'loadingAnimationStore'
  )(observer(InternalDocumentSignDetail))
)
